<template>
    <div class="page-wrap">
        <div class="page-bar">
            <div>
                <div class="page-bar-sub">Settings</div>
                <div class="page-bar-main">Configuration</div>
            </div>
        </div>
        <div :class="$store.state.routeLoaded ? 'slide-up view' : 'hide'">
            <settings-layout :desc="type == 'teamhub' ? 'Employee teams and the fields kept on employee records and reviews.' : 'Company identity and the lists used across your Ironbook.'">
                <div v-if="$store.state.user.teamHubRole == 'Admin' && $store.state.user.role == 'Admin'" class="settings-seg">
                    <div class="seg seg-dark">
                        <button @click="() => { type = 'playbook' }" :class="type == 'playbook' ? 'on' : ''">Content</button>
                        <button @click="() => { type = 'teamhub' }" :class="type == 'teamhub' ? 'on' : ''">Team Hub</button>
                    </div>
                </div>
                <div class="form-wrapper settings-form">
                    <div v-if="type == 'playbook'">
                        <section class="settings-card">
                            <div>
                                <h3>Company Name</h3>
                                <input type="text" v-model="formData.Name" />
                            </div>
                            <div style="margin-bottom:25px">
                                <h3>Dark Logo</h3>
                                <img v-if="formData.LogoPath" style="max-height:45px;margin-bottom:12px" :src="$store.state.spacesUrlPublic + formData.LogoPath" />
                                <drop-file @fileChange="onLogoChange" />
                            </div>
                            <div style="margin-bottom:25px">
                                <h3>Light Logo</h3>
                                <div class="chip-editor-hint" style="margin-bottom:12px">This logo will be used in the header of your Ironbook and in your emails. It will be presented over a dark gray background. Use a white or light colored logo with transparency.</div>
                                <div style="padding:30px;background:var(--dark-gray);margin-bottom: 20px;display:flex;justify-content:center">
                                    <img v-if="formData.LightLogoPath" style="height:45px;margin:0 0 10px" :src="$store.state.spacesUrlPublic + formData.LightLogoPath" />
                                </div>
                                <drop-file @fileChange="onLightLogoChange" />
                            </div>
                            <!-- Have to register domain for this
                            <div>
                                <h3>Domain</h3>
                                <input type="text" v-model="formData.Domain" />
                            </div>
                            -->
                            <div>
                                <h3>Primary Color</h3>
                                <input type="color" v-model="formData.PrimaryColor" style="margin-bottom:0" />
                            </div>
                        </section>
                        <section class="settings-card"><chip-list-editor v-model="formData.LocationsNew" label="Locations" placeholder="Add location..." /></section>
                        <section class="settings-card"><chip-list-editor v-model="formData.DepartmentsNew" label="Departments" placeholder="Add department..." /></section>
                        <section class="settings-card"><chip-list-editor v-model="formData.NodeTypesNew" label="Node Types" placeholder="Add node type..." /></section>
                    </div>
                    <div v-else-if="type == 'teamhub'">
                        <section class="settings-card"><chip-list-editor v-model="formData.EmployeeTeamsNew" label="Employee Teams" placeholder="Add team..." /></section>
                        <section class="settings-card">
                            <h3><a @click.prevent="() => { showEmployeeFields = !showEmployeeFields }" style="text-decoration:underline">Employee Fields</a></h3>
                            <div v-if="showEmployeeFields">
                                <draggable :list="formData.EmployeeFieldsNew">
                                    <div v-for="(field, i) in formData.EmployeeFieldsNew" :key="i" class="edit-form-field">
                                        <div class="form-close">
                                            <svg @click="removeListItem(formData.EmployeeFieldsNew, i)" fill="red" style="width:18px;height:18px" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.538l-4.592-4.548 4.546-4.587-1.416-1.403-4.545 4.589-4.588-4.543-1.405 1.405 4.593 4.552-4.547 4.592 1.405 1.405 4.555-4.596 4.591 4.55 1.403-1.416z"/></svg>
                                        </div>
                                        <input type="text" placeholder="Name" v-model="field.name" />
                                        <select v-model="field.type">
                                            <option value="text">Text</option>
                                            <option value="multitext">Multi-Line Text</option>
                                            <option value="date">Date</option>
                                            <option value="select">Select</option>
                                        </select>
                                        <div v-if="field.type == 'select'" class="edit-form-field">
                                            <draggable :list="field.options">
                                                <div v-for="(option, j) in field.options" :key="'o'+j" style="position:relative">
                                                    <input style="padding:5px 0;border:0;margin:0" type="text" v-model="field.options[j]" />
                                                    <div class="form-close">
                                                        <svg-icon @click="removeListItem(field.options, j)" style="color:red;width:12px;height:12px" icon="x" />
                                                    </div>
                                                </div>
                                            </draggable>
                                            <form @submit.prevent="addOption(field)" style="display:flex;margin:5px 0">
                                                <input style="flex:1;margin-bottom:0" type="text" v-model="field.optionInput" placeholder="Add Option" />
                                                <button class="add-btn">Add</button>
                                            </form>
                                        </div>
                                        <div class="checkbox-input" style="margin-top:10px">
                                            <input type="checkbox" v-model="field.collectOnRegistration" />
                                            <div>Collect on Registration</div>
                                        </div>
                                        <div v-if="field.collectOnRegistration" class="checkbox-input" style="margin-top:10px">
                                            <input type="checkbox" v-model="field.requiredOnRegistration" />
                                            <div>Required on Registration</div>
                                        </div>
                                        <div class="checkbox-input" style="margin-top:10px">
                                            <input type="checkbox" v-model="field.secure" />
                                            <div>Secure Data</div>
                                        </div>
                                        <div v-if="field.type == 'date'" class="checkbox-input" style="margin-top:10px">
                                            <input type="checkbox" v-model="field.celebrationDate" />
                                            <div>Celebration Date</div>
                                        </div>
                                        <div v-if="field.type == 'date' && field.celebrationDate">
                                            <input type="text" placeholder="Celebration Name" v-model="field.celebrationName" />
                                        </div>
                                    </div>
                                </draggable>
                                <div style="display:flex">
                                    <div @click="addItem(formData.EmployeeFieldsNew)" class="add-btn">Add Item</div>
                                </div>
                            </div>
                        </section>
                        <section class="settings-card">
                            <h3><a @click.prevent="() => { showEmployeeReviewFields = !showEmployeeReviewFields }" style="text-decoration:underline">Employee Review Fields</a></h3>
                            <div v-if="showEmployeeReviewFields">
                                <draggable :list="formData.EmployeeReviewFieldsNew">
                                    <div v-for="(field, i) in formData.EmployeeReviewFieldsNew" :key="i" class="edit-form-field">
                                        <div class="form-close">
                                            <svg @click="removeListItem(formData.EmployeeReviewFieldsNew, i)" fill="red" style="width:18px;height:18px" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.538l-4.592-4.548 4.546-4.587-1.416-1.403-4.545 4.589-4.588-4.543-1.405 1.405 4.593 4.552-4.547 4.592 1.405 1.405 4.555-4.596 4.591 4.55 1.403-1.416z"/></svg>
                                        </div>
                                        <input type="text" placeholder="Name" v-model="field.name" />
                                        <select v-model="field.type">
                                            <option value="text">Text</option>
                                            <option value="multitext">Multi-Line Text</option>
                                            <option value="date">Date</option>
                                            <option value="select">Select</option>
                                        </select>
                                        <div v-if="field.type == 'select'" class="edit-form-field">
                                            <draggable :list="field.options">
                                                <div v-for="(option, j) in field.options" :key="'o'+j" style="position:relative">
                                                    <input style="padding:5px 0;border:0;margin:0" type="text" v-model="field.options[j]" />
                                                    <div class="form-close">
                                                        <svg-icon @click="removeListItem(field.options, j)" style="color:red;width:12px;height:12px" icon="x" />
                                                    </div>
                                                </div>
                                            </draggable>
                                            <form @submit.prevent="addOption(field)" style="display:flex;margin:5px 0">
                                                <input style="flex:1;margin-bottom:0" type="text" v-model="field.optionInput" placeholder="Add Option" />
                                                <button class="add-btn">Add</button>
                                            </form>
                                        </div>
                                    </div>
                                </draggable>
                                <div style="display:flex">
                                    <div @click="addItem(formData.EmployeeReviewFieldsNew)" class="add-btn">Add Item</div>
                                </div>
                            </div>
                        </section>
                    </div>

                    <div class="btn-row settings-save">
                        <button type="button" class="btn-lg" :disabled="disableButton" @click="submit()">Save Changes</button>
                    </div>
                </div>
            </settings-layout>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
import { VueDraggableNext } from 'vue-draggable-next';
import SvgIcon from '@/components/SvgIcon.vue';
import DropFile from '@/components/DropFile.vue';
import ChipListEditor from '@/components/ChipListEditor.vue';
import SettingsLayout from '@/components/SettingsLayout.vue';
import { v4 as uuidv4 } from 'uuid';

export default defineComponent({
    name: 'ConfigurationView',
    components: {
        draggable: VueDraggableNext,
        SvgIcon,
        DropFile,
        ChipListEditor,
        SettingsLayout,
    },
    data() {
        return {
            formData: {
                DepartmentsJSON: '',
                LocationsJSON: '',
                NodeTypesJSON: '',
                EmployeeFieldsJSON: '',
                EmployeeReviewFieldsJSON: '',
                EmployeeTeamsJSON: '',
                Name: '',
                Domain: '',
                LogoPath: '',
                LightLogoPath: '',
                PrimaryColor: '',
                DepartmentsNew: [] as any,
                LocationsNew: [] as any,
                NodeTypesNew: [] as any,
                EmployeeFieldsNew: [] as any,
                EmployeeReviewFieldsNew: [] as any,
                EmployeeTeamsNew: [] as any
            },
            disableButton: false,
            type: 'playbook',
            showEmployeeFields: false,
            showEmployeeReviewFields: false
        }
    },
    async created() {
        if(this.$route.query.type && this.$store.state.user.teamHubRole == 'Admin' && this.$store.state.user.role == 'Admin') {
            this.type = this.$route.query.type;
        }
        await this.getConfiguration();

        this.$store.state.routeLoaded = true;
    },
    methods: {
        async getConfiguration() {
            await axios.get(`${this.$store.state.apiUrl}/api/companyconfig`)
                .then(resp => {
                    this.formData = resp.data;
                    if(this.formData.DepartmentsJSON) {
                        this.formData.DepartmentsNew = JSON.parse(this.formData.DepartmentsJSON);
                    } else {
                        this.formData.DepartmentsNew = [];
                    }
                    if(this.formData.LocationsJSON) {
                        this.formData.LocationsNew = JSON.parse(this.formData.LocationsJSON);
                    } else {
                        this.formData.LocationsNew = [];
                    }
                    if(this.formData.NodeTypesJSON) {
                        this.formData.NodeTypesNew = JSON.parse(this.formData.NodeTypesJSON);
                    } else {
                        this.formData.NodeTypesNew = [];
                    }
                    if(this.formData.EmployeeFieldsJSON) {
                        this.formData.EmployeeFieldsNew = JSON.parse(this.formData.EmployeeFieldsJSON);
                    } else {
                        this.formData.EmployeeFieldsNew = [];
                    }
                    if(this.formData.EmployeeReviewFieldsJSON) {
                        this.formData.EmployeeReviewFieldsNew = JSON.parse(this.formData.EmployeeReviewFieldsJSON);
                    } else {
                        this.formData.EmployeeReviewFieldsNew = [];
                    }
                    if(this.formData.EmployeeTeamsJSON) {
                        this.formData.EmployeeTeamsNew = JSON.parse(this.formData.EmployeeTeamsJSON);
                    } else {
                        this.formData.EmployeeTeamsNew = [];
                    }
                })
                .catch(e => {
                    console.log(e);
                })
        },
        async submit() {
            if(!this.formData.LocationsNew.length) {
                alert('Include at least one location');
                return;
            }
            if(!this.formData.DepartmentsNew.length) {
                alert('Include at least one department');
                return;
            }
            if(!this.formData.NodeTypesNew.length) {
                alert('Include at least one node type');
                return;
            }

            this.formData.LocationsJSON = JSON.stringify(this.formData.LocationsNew);
            this.formData.DepartmentsJSON = JSON.stringify(this.formData.DepartmentsNew);
            this.formData.NodeTypesJSON = JSON.stringify(this.formData.NodeTypesNew);
            this.formData.EmployeeFieldsJSON = JSON.stringify(this.formData.EmployeeFieldsNew);
            this.formData.EmployeeReviewFieldsJSON = JSON.stringify(this.formData.EmployeeReviewFieldsNew);
            this.formData.EmployeeTeamsJSON = JSON.stringify(this.formData.EmployeeTeamsNew);

            this.disableButton = true;

            await axios.post(`${this.$store.state.apiUrl}/api/companyconfig`, this.formData)
                .then(resp => {
                    this.$store.dispatch('setStoreData');
                    this.$store.state.user.logoPath = this.formData.LogoPath;
                    alert('Configuration has been updated!')
                })
                .catch(e => {
                    alert('There was an error')
                    console.log(e);
                })

            this.disableButton = false;
        },
        async onLogoChange(file: any) {
            if(!file) {
                return;
            }

            const formData = new FormData();
            formData.append('file', file);
            await axios.post(`${this.$store.state.apiUrl}/api/companyconfig/companyimage`, formData)
                .then(resp => {
                    if(resp?.data?.key) {
                        this.formData.LogoPath = resp.data.key;
                        this.$forceUpdate();
                    } else {
                        alert('There was an error')
                    }
                })
                .catch(e => {
                    alert('There was an error')
                    console.log(e);
                })
        },
        async onLightLogoChange(file: any) {
            if(!file) {
                return;
            }

            const formData = new FormData();
            formData.append('file', file);
            await axios.post(`${this.$store.state.apiUrl}/api/companyconfig/lightcompanyimage`, formData)
                .then(resp => {
                    if(resp?.data?.key) {
                        this.formData.LightLogoPath = resp.data.key;
                        this.$forceUpdate();
                    } else {
                        alert('There was an error')
                    }
                })
                .catch(e => {
                    alert('There was an error')
                    console.log(e);
                })
        },
        removeListItem(list: any, i: number) {
            list.splice(i, 1);
        },
        addOption(field: any) {
            if(!field.optionInput) {
                return;
            }
            if(!field.options) {
                field.options = [];
            }
            field.options.push(field.optionInput.trim());
            field.optionInput = '';
            this.$forceUpdate();
        },
        addItem(list: any) {
            list.push({
                id: uuidv4(),
                name: '',
                type: 'text'
            })
        }
    }
});
</script>
